export const brand = {
  name: "Aden's Viennoiserie",
  logo: 'https://cdn.magicpatterns.com/uploads/97JQgkCvEtWmWjbf51CDFw/adens-logo-dark-scaled.png',
  video: 'https://adens.nl/wp-content/uploads/2025/10/adens.mp4',
  tagline: 'Layers of gold, moments of joy',
  address: ['Burgemeester de Vlugtlaan 198', '1063 JJ, Amsterdam'],
  rating: '4.8',
  reviewCount: 102,
}

export const nav = [
  { label: 'App', href: '#app' },
  { label: 'Kaart', href: '#kaart' },
  { label: 'Ambacht', href: '#ambacht' },
  { label: 'Bezoek', href: '#bezoek' },
]

export const images = {
  poster:
    'https://cdn.magicpatterns.com/uploads/9fTB4p2VxsCq2aQyj2qhJF/web-adens-product-intro-100.webp',
  cheesecake: 'https://cdn.magicpatterns.com/uploads/sMB7RFCP5j6aqrEufqJ2ts/adens-112.jpg',
  painAuChocolat:
    'https://cdn.magicpatterns.com/uploads/ch2AyjqFiGi4d4nG9aJv9m/web-adens-inline-img-100.webp',
  signatureWide:
    'https://cdn.magicpatterns.com/uploads/vzeVPGw8viM48ZCf2HUQ7a/web-adens-layers-of-gold-102.webp',
  interior:
    'https://cdn.magicpatterns.com/patterns/generated-images/8943b87c-a8f6-4395-8560-9c4bd9f88901.jpg',
  barista:
    'https://cdn.magicpatterns.com/patterns/generated-images/c705ffb8-4eb6-4587-84dc-a9938b343faf.jpg',
  terrace:
    'https://cdn.magicpatterns.com/patterns/generated-images/1e9d3192-3eaf-49c1-851a-b9e968a80c09.jpg',
  icedLatte: 'https://cdn.magicpatterns.com/uploads/hXve1DM3npZg2wYC9UnBPf/DSC_2843-lq.jpg',
  counter:
    'https://cdn.magicpatterns.com/uploads/dAVpGHydH7iLHSXDTd58hf/web-adens-product-intro-102.webp',
  phoneHome:
    'https://cdn.magicpatterns.com/uploads/bvghRmNWJ5irMBmorXMefF/adens-app-store-image-scaled.png',
  phoneReward:
    'https://cdn.magicpatterns.com/uploads/kAC8Z6uV3bYYb1tc1sv1oK/adens-app-store-image-200-scaled.png',
}

export const appSteps = [
  {
    index: '01',
    title: 'Download',
    body: 'Maak in dertig seconden een account aan en ontvang direct je welkomstcadeau: een gratis koffie naar keuze.',
  },
  {
    index: '02',
    title: 'Check-in',
    body: 'Scan de QR-code aan de toonbank bij elk bezoek. Je punten staan meteen op je digitale kaart.',
  },
  {
    index: '03',
    title: 'Verzilver',
    body: 'Wissel punten in voor espresso, viennoiserie en seizoensdrops die alleen in de app verschijnen.',
  },
]

export const rail = [
  {
    id: 'amandes',
    index: '01',
    name: 'Croissant aux amandes',
    note: 'Amandelcrème, poedersuiker',
    image:
      'https://cdn.magicpatterns.com/uploads/vzeVPGw8viM48ZCf2HUQ7a/web-adens-layers-of-gold-102.webp',
    wide: true,
  },
  {
    id: 'fraise',
    index: '02',
    name: 'Fraise & crème',
    note: 'Bladerdeeg, vanilleroom, aardbei',
    image:
      'https://cdn.magicpatterns.com/uploads/stZYdyWMmqdVCyudayGKSj/web-adens-layers-of-gold-101.webp',
    wide: true,
  },
  {
    id: 'paris-brest',
    index: '03',
    name: 'Paris-Brest',
    note: 'Hazelnootpraliné, karamellak',
    image:
      'https://cdn.magicpatterns.com/uploads/5QuYHmkbBTZysTdpSQKZmh/web-adens-layers-of-gold-100.webp',
    wide: true,
  },
  {
    id: 'cheesecake',
    index: '04',
    name: 'Cheesecake rouge',
    note: 'Speculooskruim, rood fruit',
    image: 'https://cdn.magicpatterns.com/uploads/sMB7RFCP5j6aqrEufqJ2ts/adens-112.jpg',
    wide: false,
  },
  {
    id: 'chocolat',
    index: '05',
    name: 'Pain au chocolat',
    note: 'Belgische chocolade, 72 uur rijs',
    image:
      'https://cdn.magicpatterns.com/uploads/ch2AyjqFiGi4d4nG9aJv9m/web-adens-inline-img-100.webp',
    wide: false,
  },
  {
    id: 'latte',
    index: '06',
    name: 'Iced latte',
    note: 'Huisblend espresso, volle melk',
    image: 'https://cdn.magicpatterns.com/uploads/hXve1DM3npZg2wYC9UnBPf/DSC_2843-lq.jpg',
    wide: false,
  },
]

export const house = [
  {
    index: '01',
    title: 'Viennoiserie',
    body: "Van boterzachte, dagverse croissants tot seizoensgebonden creaties — elk stuk met Franse elegantie en de beste ingrediënten in-house gemaakt. Volledig halal bereid.",
    image:
      'https://cdn.magicpatterns.com/uploads/9fTB4p2VxsCq2aQyj2qhJF/web-adens-product-intro-100.webp',
  },
  {
    index: '02',
    title: 'Koffie',
    body: 'Zorgvuldig geselecteerde bonen die de rijke smaken van onze patisserie complementeren. Van stevige espresso tot romige cappuccino, op het terras of in de zaak.',
    image: 'https://cdn.magicpatterns.com/uploads/hXve1DM3npZg2wYC9UnBPf/DSC_2843-lq.jpg',
  },
  {
    index: '03',
    title: 'Community',
    body: "Aden's is meer dan een bakkerij: een ontmoetingsplek in Nieuw-West, vlakbij Plein 40-45, waar kwaliteit en hart voor de zaak samenkomen.",
    image:
      'https://cdn.magicpatterns.com/uploads/dAVpGHydH7iLHSXDTd58hf/web-adens-product-intro-102.webp',
  },
]

export const featuredReview = {
  name: 'Kemaleddin Köse',
  quote:
    "Aden's Viennoiserie is echt een verborgen parel. De croissants zijn supervers, knapperig van buiten en heerlijk zacht van binnen.",
}

export const reviews = [
  {
    name: 'Meva Meryem Turan',
    quote: 'Beste croissantjes van Amsterdam Nieuw-West. Personeel is ook echt top!',
  },
  {
    name: 'Irem Halci',
    quote:
      'Al het eten wat je op hun social media ziet, is ook hoe het er in het echt uitziet. Herhaling zeker vatbaar!',
  },
  {
    name: 'Dina K',
    quote: 'Overheerlijk broodje kip en als toetje een geweldige pistache gebakje. Een dikke 10!',
  },
]

export const hours = [
  { day: 'Maandag', time: '08:00 – 22:00' },
  { day: 'Dinsdag', time: '08:00 – 22:00' },
  { day: 'Woensdag', time: '08:00 – 22:00' },
  { day: 'Donderdag', time: '08:00 – 22:00' },
  { day: 'Vrijdag', time: '08:00 – 22:00' },
  { day: 'Zaterdag', time: '08:00 – 22:00' },
  { day: 'Zondag', time: '08:00 – 22:00' },
]
